import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import cookies from 'react-cookies';
import Grid from '@material-ui/core/Grid';
import { LOGIN_URL } from 'src/constants/constants.js';
import LanguageContainer from 'src/ui/features/Login/containers/LanguageContainer';
import intl from 'react-intl-universal';

export const LoginLayout = props => {
  const cook = cookies.load('HashCookie');
  const { isRoleSelect, children } = props;

  const loginWithEYBackground = childrenComps => (
    <div>
      <div className="row">
        <div className="header-logo" />
        <LanguageContainer />
      </div>
      <div>
        <div className={`header-image`}>
          <div className="iso">
            <div className="dots">
              <span className="square" />
              <span className="square" />
              <span className="square" />
            </div>
            <div className="legend">{intl.get('default.title')}</div>
          </div>
          <div className="baseline" />
        </div>
      </div>
      <div>
        <div className={`login_content`}>
          <Grid container spacing={3} classes={{ container: '' }}>
            {childrenComps}
          </Grid>
        </div>
      </div>
    </div>
  );

  const rolePickNoEYBackground = childrenComps => (
    <div className={`login_content`}>
      <Grid container spacing={24} classes={{ container: '' }}>
        {childrenComps}
      </Grid>
    </div>
  );

  return props.skipAuth || cook ? (
    !isRoleSelect ? (
      loginWithEYBackground(children)
    ) : (
      rolePickNoEYBackground(children)
    )
  ) : (
    <Redirect to={LOGIN_URL} />
  );
};

LoginLayout.propTypes = {
  skipAuth: PropTypes.bool,
};

LoginLayout.defaultProps = {
  skipAuth: false,
};

export default LoginLayout;
